import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CubiquePrivacyComponent } from './cubique/privacy/cubique-privacy.component';
import { CubiqueSupportComponent } from './cubique/support/cubique-support.component';
import { CubiqueComponent } from './cubique/cubique.component';
import { MirinVerifyComponent } from './mirin-verify/mirin-verify.component';
import { MirinVerifyPrivacyComponent } from './mirin-verify/privacy/mirin-verify-privacy.component';
import { MirinVerifySupportComponent } from './mirin-verify/support/mirin-verify-support.component';

const routes: Routes = [
  { path: 'cubique', component: CubiqueComponent },
  { path: 'cubique/privacy', component: CubiquePrivacyComponent },
  { path: 'cubique/support', component: CubiqueSupportComponent},
  { path: 'mirin-verify', component: MirinVerifyComponent },
  { path: 'mirin-verify/privacy', component: MirinVerifyPrivacyComponent },
  { path: 'mirin-verify/support', component: MirinVerifySupportComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
